function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#E0DBD5;stroke:#1D1D1D;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#18988B;}\n\t.st2{fill:none;stroke:#1D1D1D;stroke-width:2;stroke-miterlimit:10;}\n\t.st3{fill:#18988B;stroke:#222222;stroke-width:2;stroke-miterlimit:10;}\n\t.st4{fill:#E43D30;stroke:#1D1D1D;stroke-width:2;stroke-miterlimit:10;}\n\t.st5{fill:#E0DBD5;stroke:#1D1D1D;stroke-width:2;stroke-miterlimit:10;}\n\t.st6{fill:#E0DBD5;stroke:#1D1D1D;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:#231F20;}\n\t.st8{fill:#E43D30;}\n\t.st9{fill:#E0DBD5;}\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 228.11,
  cy: 221.36,
  r: 29.89
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 192.26,
  y1: 205.42,
  x2: 202.87,
  y2: 205.42
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 192.26,
  y1: 237.3,
  x2: 202.87,
  y2: 237.3
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 28.55,
  y: 335.33,
  className: "st1",
  width: 164.02,
  height: 58.18
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 28.64,
  y: 194.24,
  className: "st2",
  width: 163.83,
  height: 200.31
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "192.48,194.14 28.64,194.14 43.73,139.39 177.39,139.39 "
});

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M52,246.33H28.58v30.04c0,6.44,5.27,11.71,11.71,11.71c6.44,0,11.71-5.27,11.71-11.7c0,0,0-0.01,0-0.01V246.33 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M52,276.36C52,276.37,52,276.37,52,276.36c0,6.45,5.27,11.71,11.71,11.71l0,0c6.44,0,11.71-5.27,11.71-11.71 v-30.04H52V276.36z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "52,246.33 52,246.33 52,276.36 52,276.37 52,276.36  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M98.84,246.33H75.42v30.16c0,6.44,5.27,11.71,11.71,11.71c6.44,0,11.71-5.27,11.71-11.7c0,0,0,0,0-0.01V246.33 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M98.85,276.49L98.85,276.49c-0.18,4.25,2.04,8.3,5.82,10.23c8.77,4.48,17.61-1.89,17.61-10.23v-30.16H99.45 c-0.33,0-0.6,0.27-0.6,0.6V276.49z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "98.85,246.33 98.84,246.33 98.84,276.49 98.85,276.49 98.85,276.49  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M145.7,246.33h-23.42v30.16c0,6.44,5.27,11.71,11.71,11.71l0,0c6.44,0,11.71-5.27,11.71-11.7 c0,0,0-0.01,0-0.01V246.33z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M145.7,276.49C145.7,276.49,145.7,276.49,145.7,276.49c0,6.45,5.27,11.71,11.71,11.71 c6.44,0,11.71-5.27,11.71-11.71v-30.16H145.7V276.49z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "145.7,246.33 145.7,246.33 145.7,276.49 145.7,276.49 145.7,276.49  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M169.12,276.49c0,6.44,5.27,11.71,11.71,11.71c6.44,0,11.71-5.27,11.71-11.71v-30.16h-23.42V276.49z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "52,246.33 52,246.33 52,245.69 52,244.92 52,244.93  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "145.7,246.33 145.7,246.33 145.7,245.05 145.7,245.04 145.7,245.05  "
}));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: 110.56,
  cy: 219.53,
  r: 18.27
}), /*#__PURE__*/React.createElement("circle", {
  className: "st4",
  cx: 110.56,
  cy: 219.53,
  r: 11.45
}));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: 58.27,
  cy: 219.53,
  r: 18.27
}), /*#__PURE__*/React.createElement("circle", {
  className: "st4",
  cx: 58.27,
  cy: 219.53,
  r: 11.45
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: 162.86,
  cy: 219.53,
  r: 18.27
}), /*#__PURE__*/React.createElement("circle", {
  className: "st4",
  cx: 162.86,
  cy: 219.53,
  r: 11.45
})));

var _ref11 = /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 28.78,
  y1: 336.24,
  x2: 192.34,
  y2: 336.24
});

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 31,
  y1: 359.3,
  x2: 35.99,
  y2: 352.01
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 174.07,
  y1: 348.79,
  x2: 179.07,
  y2: 341.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 54.85,
  y1: 363.09,
  x2: 51.47,
  y2: 354.93
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 132.05,
  y1: 351.87,
  x2: 140.27,
  y2: 348.64
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 116.95,
  y1: 395.32,
  x2: 113.57,
  y2: 387.16
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 88.73,
  y1: 356.9,
  x2: 81.07,
  y2: 352.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 153.02,
  y1: 385.96,
  x2: 145.36,
  y2: 381.56
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 59.77,
  y1: 345.65,
  x2: 67.66,
  y2: 341.67
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 115.91,
  y1: 338.22,
  x2: 124.14,
  y2: 341.43
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 146.58,
  y1: 376.27,
  x2: 143.3,
  y2: 368.06
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 47.02,
  y1: 341.07,
  x2: 39.32,
  y2: 336.75
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 160.31,
  y1: 348.08,
  x2: 152.61,
  y2: 343.76
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 98.07,
  y1: 339.29,
  x2: 92.87,
  y2: 346.42
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 92.99,
  y1: 378.44,
  x2: 85.28,
  y2: 374.12
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 134.07,
  y1: 369.32,
  x2: 125.31,
  y2: 370.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 41.65,
  y1: 380.7,
  x2: 47.9,
  y2: 374.46
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 77.04,
  y1: 369.21,
  x2: 71.97,
  y2: 376.45
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 106.66,
  y1: 346.16,
  x2: 113.69,
  y2: 351.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 66.37,
  y1: 388.84,
  x2: 74.6,
  y2: 385.65
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 33.82,
  y1: 386.53,
  x2: 39.08,
  y2: 393.62
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 98.79,
  y1: 384.58,
  x2: 93.72,
  y2: 391.82
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 131.63,
  y1: 378.46,
  x2: 126.57,
  y2: 385.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 105.35,
  y1: 377.08,
  x2: 114.01,
  y2: 375.33
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 31.66,
  y1: 371.8,
  x2: 40.12,
  y2: 369.25
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 186.05,
  y1: 363.09,
  x2: 182.67,
  y2: 354.93
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 183.87,
  y1: 380.12,
  x2: 190.13,
  y2: 373.88
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 171.41,
  y1: 387.69,
  x2: 176.67,
  y2: 394.78
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 166.93,
  y1: 372.96,
  x2: 175.38,
  y2: 370.41
}));

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M106.45,363.18v40.78c0,2.27,1.84,4.11,4.11,4.11h0c2.27,0,4.11-1.84,4.11-4.11v-40.78 c0-2.27-1.84-4.11-4.11-4.11h0C108.29,359.07,106.45,360.91,106.45,363.18z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M126.45,355.35H94.67c-2.27,0-4.11,1.84-4.11,4.11l0,0c0,2.27,1.84,4.11,4.11,4.11h31.78 c2.27,0,4.11-1.84,4.11-4.11l0,0C130.56,357.19,128.72,355.35,126.45,355.35z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M56.41,363.18v40.78c0,2.27,1.84,4.11,4.11,4.11h0c2.27,0,4.11-1.84,4.11-4.11v-40.78 c0-2.27-1.84-4.11-4.11-4.11h0C58.25,359.07,56.41,360.91,56.41,363.18z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M76.41,355.35H44.63c-2.27,0-4.11,1.84-4.11,4.11l0,0c0,2.27,1.84,4.11,4.11,4.11h31.78 c2.27,0,4.11-1.84,4.11-4.11l0,0C80.52,357.19,78.68,355.35,76.41,355.35z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M156.49,363.18v40.78c0,2.27,1.84,4.11,4.11,4.11l0,0c2.27,0,4.11-1.84,4.11-4.11v-40.78 c0-2.27-1.84-4.11-4.11-4.11l0,0C158.33,359.07,156.49,360.91,156.49,363.18z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M176.49,355.35h-31.78c-2.27,0-4.11,1.84-4.11,4.11l0,0c0,2.27,1.84,4.11,4.11,4.11h31.78 c2.27,0,4.11-1.84,4.11-4.11l0,0C180.6,357.19,178.76,355.35,176.49,355.35z"
}))));

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 43.73,
  y: 125.45,
  className: "st4",
  width: 133.65,
  height: 13.94
});

var _ref15 = /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 110.56,
  y1: 124.1,
  x2: 110.56,
  y2: 37.51
});

var _ref16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "110.63,37.63 110.63,76.23 120.93,71.19 120.93,42.67  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "120.93,42.67 120.93,71.19 150.03,56.93  "
}));

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M249.26,207.24c-0.09-0.1-0.18-0.19-0.25-0.26c-1.74-1.69-3.66-3.16-5.72-4.36c-2.3-1.36-4.79-2.4-7.37-3.1 c-0.18-0.05-0.37-0.07-0.55-0.07c-0.83,0-1.6,0.47-1.95,1.24l-2.12,4.6c-0.26,0.59-0.26,1.27,0.02,1.84 c0.29,0.59,0.82,0.99,1.45,1.15c1.34,0.3,2.65,0.76,3.9,1.33l-8.52,18.5l-8.51-18.5c1.24-0.57,2.54-1.03,3.89-1.33 c0.63-0.15,1.15-0.56,1.44-1.15c0.28-0.58,0.29-1.26,0.02-1.84l-2.12-4.6c-0.35-0.77-1.12-1.24-1.95-1.24 c-0.18,0-0.37,0.02-0.55,0.07c-2.57,0.7-5.06,1.73-7.36,3.09c-2.06,1.22-3.99,2.69-5.71,4.36c-0.12,0.11-0.22,0.22-0.34,0.34 c-0.61,0.64-0.76,1.58-0.4,2.39l2.25,4.88c0.3,0.67,0.93,1.13,1.67,1.23c0.09,0.02,0.19,0.02,0.28,0.02c0.52,0,1.02-0.19,1.41-0.53 l14.03,30.5c0.35,0.76,1.11,1.24,1.95,1.24s1.6-0.48,1.95-1.24l14.03-30.52c0.37,0.3,0.83,0.45,1.31,0.45 c0.09,0,0.18-0.01,0.29-0.02c0.72-0.1,1.36-0.56,1.66-1.23l2.24-4.88C250,208.81,249.85,207.87,249.26,207.24z M210.77,213.69 l-2.25-4.89l0.28-0.28c1.6-1.56,3.38-2.93,5.31-4.06c2.12-1.25,4.4-2.21,6.83-2.86l2.12,4.59c-2.29,0.52-4.46,1.4-6.43,2.57 c-1.59,0.92-3.06,2.04-4.35,3.33C211.75,212.59,211.24,213.13,210.77,213.69z M228.16,244.91l-14.46-31.44 c1.19-1.16,2.52-2.18,3.96-3.03l10.5,22.81l10.49-22.81c1.44,0.85,2.77,1.87,3.96,3.03L228.16,244.91z M245.45,213.57 c-0.44-0.52-0.91-1.02-1.4-1.49c-1.32-1.28-2.77-2.41-4.36-3.33c-1.97-1.17-4.14-2.04-6.44-2.57l2.12-4.59 c2.43,0.65,4.72,1.61,6.83,2.86c1.94,1.13,3.71,2.5,5.31,4.06c0.06,0.06,0.13,0.11,0.18,0.18L245.45,213.57z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M242.61,213.47l-14.45,31.44l-14.46-31.44c1.19-1.16,2.52-2.18,3.96-3.03l10.5,22.81l10.49-22.81 C240.1,211.29,241.43,212.31,242.61,213.47z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M247.69,208.7l-2.24,4.88c-0.44-0.52-0.91-1.02-1.4-1.49c-1.32-1.28-2.77-2.41-4.36-3.33 c-1.97-1.17-4.14-2.04-6.44-2.57l2.12-4.59c2.43,0.65,4.72,1.61,6.83,2.86c1.94,1.13,3.71,2.5,5.31,4.06 C247.58,208.58,247.64,208.63,247.69,208.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M223.06,206.19c-2.29,0.52-4.46,1.4-6.43,2.57c-1.59,0.92-3.06,2.04-4.35,3.33c-0.53,0.51-1.03,1.04-1.51,1.61 l-2.25-4.89l0.28-0.28c1.6-1.56,3.38-2.93,5.31-4.06c2.12-1.25,4.4-2.21,6.83-2.86L223.06,206.19z"
}));

function SvgPuesto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 277 447",
    style: {
      enableBackground: "new 0 0 277 447"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuesto);
export default __webpack_public_path__ + "static/media/puesto.37c72eea.svg";
export { ForwardRef as ReactComponent };